/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { JWTTokenFromJSON, ResumePraticaDtoFromJSON, SessionResponseDtoFromJSON, SignUpDtoToJSON, UserSessionDTOToJSON, VerifyLinkDtoFromJSON, } from '../models';
/**
 *
 */
export class AuthenticationApi extends runtime.BaseAPI {
    /**
     * Authorize endpoint
     * This method is for authorization management
     */
    authorizeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.isTest === null || requestParameters.isTest === undefined) {
                throw new runtime.RequiredError('isTest', 'Required parameter requestParameters.isTest was null or undefined when calling authorize.');
            }
            if (requestParameters.signUpDto === null || requestParameters.signUpDto === undefined) {
                throw new runtime.RequiredError('signUpDto', 'Required parameter requestParameters.signUpDto was null or undefined when calling authorize.');
            }
            const queryParameters = {};
            if (requestParameters.isTest !== undefined) {
                queryParameters['isTest'] = requestParameters.isTest;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/public/authenticate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SignUpDtoToJSON(requestParameters.signUpDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SessionResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Authorize endpoint
     * This method is for authorization management
     */
    authorize(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authorizeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    resumePraticaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.data === null || requestParameters.data === undefined) {
                throw new runtime.RequiredError('data', 'Required parameter requestParameters.data was null or undefined when calling resumePratica.');
            }
            const queryParameters = {};
            if (requestParameters.data !== undefined) {
                queryParameters['data'] = requestParameters.data;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/public/resumePratica`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ResumePraticaDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    resumePratica(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.resumePraticaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    sendResumeLinkRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.email === null || requestParameters.email === undefined) {
                throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling sendResumeLink.');
            }
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/public/sendResumeLink`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    sendResumeLink(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.sendResumeLinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Verify Link endpoint
     * This method is for authorization management
     */
    verifyLinkRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.data === null || requestParameters.data === undefined) {
                throw new runtime.RequiredError('data', 'Required parameter requestParameters.data was null or undefined when calling verifyLink.');
            }
            const queryParameters = {};
            if (requestParameters.data !== undefined) {
                queryParameters['data'] = requestParameters.data;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/public/verifyLink`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => VerifyLinkDtoFromJSON(jsonValue));
        });
    }
    /**
     * Verify Link endpoint
     * This method is for authorization management
     */
    verifyLink(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.verifyLinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Verify Otp endpoint
     * This method is for authorization management
     */
    verifyOtpRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userSessionDTO === null || requestParameters.userSessionDTO === undefined) {
                throw new runtime.RequiredError('userSessionDTO', 'Required parameter requestParameters.userSessionDTO was null or undefined when calling verifyOtp.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Authentication", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/public/verifyOtp`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserSessionDTOToJSON(requestParameters.userSessionDTO),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => JWTTokenFromJSON(jsonValue));
        });
    }
    /**
     * Verify Otp endpoint
     * This method is for authorization management
     */
    verifyOtp(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.verifyOtpRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
